import CONSTANTS from "../../assets/js/Constants";

//reducer gồm các hàm update trạng thái dựa vào kết quả từ api
const norm_configuration = {};
export default function (state = norm_configuration, { type, payload }) {
    switch (type) {
        case CONSTANTS.ACTION.NORM_CONFIGURATION.SET_VEHICLE_LIST:
            return { ...state, vehicleList: payload };
        case CONSTANTS.ACTION.NORM_CONFIGURATION.SET_VEHICLE_GROUPS:
            return { ...state, vehicleGroups: payload };
        case CONSTANTS.ACTION.NORM_CONFIGURATION.SET_VEHICLE_SETTINGS:
            return { ...state, vehicleSettings: payload };
        case CONSTANTS.ACTION.NORM_CONFIGURATION.SET_SAVE_ACTION:
            return { ...state, saveAction: payload };
        case CONSTANTS.ACTION.NORM_CONFIGURATION.SET_DELETE_ACTION:
            return { ...state, deleteAction: payload };
        default:
            return { ...state };
    }
}